export default "__VITE_ASSET__NY1nnnId__"